/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MainContactResponse } from '../../models/main-contact-response';

export interface GetOfferMainContact$Params {
  id: number;
}

export function getOfferMainContact(http: HttpClient, rootUrl: string, params: GetOfferMainContact$Params, context?: HttpContext): Observable<StrictHttpResponse<MainContactResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferMainContact.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MainContactResponse>;
    })
  );
}

getOfferMainContact.PATH = '/offers/{id}/contact';
